module.exports = __webpack_public_path__ + "img/PL09161.0ddcf2e9.png";